import type { Set } from '@gonfalon/immutable-shim/immutableShim';
import type { ImmutableMap } from '@gonfalon/legacy-immutable/immutableUtils';

import type { Rollout } from '#utils/flags/records/Rollout';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type VariationValue = any;

export type ClientSideAvailability = ImmutableMap<{ usingMobileKey: boolean; usingEnvironmentId: boolean }>;

export type FlagPurpose = 'migration' | 'holdout' | 'ai';

export type FlagMigrationSettings = {
  stageCount: number;
  contextKind?: string;
};

export enum RuleLabel {
  RULE = 'rule',
  COHORT = 'cohort',
}

export type VariationOrRollout = {
  variation?: number;
  rollout?: Rollout;
};

// This is tricky: value can be any valid property type on flag, including on nested properties (since field can point to nested properties).
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type FlagValue = any;

export type CustomProperty = ImmutableMap<{
  key: string;
  name: string;
  value: Set<string>;
}>;
